import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.url = this.getData('url') || '/'
        this.call('goTo', [this.url], 'Load')
    }
}
